import React, {useEffect, useState} from 'react';
import "./completed-style.scss";
import iconSuccess from './images/completed-new-success.svg';
import iconError from './images/completed-new-error.svg';
import iconCopy from './images/completed-copy.svg';
import OnboardButton from "../onboard-button-component/OnboardButton";
import {useTranslation} from "react-i18next";
import {changePrice} from "../../../util/Currency";
import parse from "html-react-parser";
import {ReactComponent as LogoFooter} from "../../../assets/images/turkish-airlines-logo/logo-turkishairlines.svg";

const CompletedComponent = (props) => {
    const {t} = useTranslation();
    const {copyText, error, visible, title, hiddenCopy, description, confirmText, confirm, remainingMiles} = props;

    const [mCopyText, setMCopyText] = useState(copyText === undefined ? null : copyText);
    const [successCopyVisible, setSuccessCopyVisible] = useState(false);

    useEffect(() => {
        setMCopyText(copyText);
    }, [copyText]);

    const copy = () => {
        navigator.clipboard.writeText(mCopyText);
        setSuccessCopyVisible(true);
    }

    return (
        visible &&
        <div className="completed-root">
            <div className="completed-root-desktop">
                <div className="completed-header"></div>
                <div className="completed-body">
                    {!error && <img className="completed-body-img" alt="logo" src={iconSuccess}/>}
                    {error && <img alt="logo" src={iconError}/>}
                    <p className="completed-body-title">{title}</p>
                    {!hiddenCopy && (
                        <p className="completed-body-title-copy">{mCopyText}
                            <img className="completed-body-img-copy" onClick={copy} alt="logo" src={iconCopy}/>
                        </p>
                    )}
                    {successCopyVisible && (
                        <p className="completed-body-copy-success">{t('copy_success')}</p>
                    )}
                    {!successCopyVisible && (
                        <p className="completed-body-copy-success">&nbsp;</p>
                    )}
                    {remainingMiles && (
                        <p className="completed-body-remaining-miles">{parse(t('payment.remaining_miles') + " <b>" + changePrice(remainingMiles) + " Mil</b>")}</p>
                    )}
                    <p className="completed-body-description">{description}</p>

                    <OnboardButton label={confirmText} onClick={() => confirm()}/>
                </div>
                <div className="completed-footer">
                    <div className="h-24"/>
                    <div className="completed-sub-footer m-b-34">
                        <LogoFooter/>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CompletedComponent;



